export const boardWBSTour = {
  key: "boardWBS",
  version: 1,
  getSteps: (t) => [
    {
      target: "body",
      content: t("Tour_BoardWBS_Tree"),
      placement: "center",
      disableBeacon: true,
    },
    {
      target: "body",
      content: t("Tour_BoardWBS_AddNode"),
      placement: "center",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-wbs-connections"]',
      content: t("Tour_BoardWBS_Connections"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-wbs-autolayout"]',
      content: t("Tour_BoardWBS_AutoLayout"),
      placement: "bottom",
    },
  ],
};
